<button class="{{ className }}" [disabled]="disableButton" (click)="onClick()">
  {{ label }}
</button>
